import { render } from "./VikingsNavigation.vue?vue&type=template&id=56047e35"
import script from "./VikingsNavigation.vue?vue&type=script&lang=js"
export * from "./VikingsNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__